import React from 'react';
import {MarkColor} from './Styles';

const ClassQuestionViewDiagnosticLegend = props => {
    return (
        <div className="flex flexCentre margin-t--l">
            <div className='flex flexColumn padding--l margin-b--l ch-emph-block'>
                <div className='flex flexCentre margin-b--l'>
                    <h4>Key</h4>
                </div>
                <div className='flex flexCentre flexAlignCentre flexSpaceBetween' style={{lineHeight: '26px'}}>
                    <div className='flex margin-r--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l'
                             style={{backgroundColor: MarkColor.CORRECT, color: '#fff', height: '26px', width: '48px'}}>
                            <div className='material-icons'>done</div>
                        </div>
                        <div>Correct</div>
                    </div>
                    <div className='flex margin-r--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l' style={{
                            backgroundColor: MarkColor.INCORRECT,
                            color: '#fff',
                            height: '26px',
                            width: '48px'
                        }}>
                            <div className='material-icons'>close</div>
                        </div>
                        <div>Incorrect</div>
                    </div>
                    <div className='flex'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l'
                             style={{backgroundColor: MarkColor.SKIPPED, color: '#fff', height: '26px', width: '48px'}}>
                            &nbsp;
                        </div>
                        <div>I don't know</div>
                    </div>
                    <div className='flex margin-l--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l'
                             style={{backgroundColor: MarkColor.UNANSWERED, color: '#fff', height: '26px', width: '48px'}}>
                            &nbsp;
                        </div>
                        <div>Unanswered</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClassQuestionViewDiagnosticLegend;